// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbs_a bhl_a bhl_q bhl_j bhl_wl bhl_bj","ImgResponsive__img":"bbs_b bhl_b bhl_ql"};